import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import { AuthService } from "../../../auth/auth.service";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {closeModal} from "../../../utils/utilities";

@Component({
  selector: 'app-header-dashboard',
  standalone: true,
  imports: [
    RouterLink,
    RouterOutlet,
    RouterLinkActive,
    ReactiveFormsModule
  ],
  templateUrl: './header-dashboard.component.html',
  styleUrl: './header-dashboard.component.css'
})
export class HeaderDashboardComponent implements OnInit{

  @ViewChild('editPassword') editPassword!: ElementRef;
  @ViewChild('sidebar') sidebar!: ElementRef;



  user: any;
  formUpdatePassword: FormGroup = new FormGroup({});
  result: any;
  dataUser: any;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    const toggleButton = document.querySelector('.toggle-sidebar-btn');
    const sidebar = document.getElementById('sidebar');

    if (toggleButton && sidebar) {
      toggleButton.addEventListener('click', () => {
        sidebar.classList.toggle('hidden');
      });
    }
    this.user = this.authService.getDatosUser();


    this.formUpdatePassword = this.fb.group({
      passOld: ['', Validators.required],
      passNew: ['', Validators.required],
      passNewRepeat: ['', Validators.required],
    });
    }


  logout() {
    this.authService.logout();
  }

  updatePassword() {
    const validator = this.validatePassword(this.formUpdatePassword.value);

    if (validator) {
      this.authService.updatePassword(this.user.email, this.formUpdatePassword.value.passOld, this.formUpdatePassword.value.passNew)
        .subscribe({
          next: (result: any) => {
            this.dataUser = result.data;
            closeModal(this.editPassword);
            this.formUpdatePassword.reset()
            alert('Contraseña actualizada correctamente');
          },

          error: (err) => alert('Error updating password:' + err)
        });
    }

  }



  validatePassword(dataPassword: any) {
    if (dataPassword.passNew !== dataPassword.passNewRepeat) {
      alert('Las contraseñas no coinciden');
      return false;
    }else if(dataPassword.passNew.length < 8){
      alert('La contraseña debe tener al menos 8 caracteres');
      return false;
    }
    else {
      return true;
    }
  }

  showHidden() {
    const isHidden =  this.sidebar.nativeElement.classList.contains('hidden');
    console.log(isHidden);
    if(isHidden) {
      this.sidebar.nativeElement.classList.remove('hidden');
    } else {
      this.sidebar.nativeElement.classList.add('hidden');
    }
  }
}
